
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report1332ShopPaymentTypeRefTypeGrid extends Serenity.EntityGrid<Report1332ShopPaymentTypeRefTypeRow, any> {
        protected getColumnsKey() { return Report1332ShopPaymentTypeRefTypeColumns.columnsKey; }
        protected getDialogType() { return Report1332ShopPaymentTypeRefTypeDialog; }
        protected getIdProperty() { return Report1332ShopPaymentTypeRefTypeRow.idProperty; }
        protected getInsertPermission() { return Report1332ShopPaymentTypeRefTypeRow.insertPermission; }
        protected getLocalTextPrefix() { return Report1332ShopPaymentTypeRefTypeRow.localTextPrefix; }
        protected getService() { return Report1332ShopPaymentTypeRefTypeService.baseUrl; }

        public DateBegin: string;
        public DateEnd: string;
        public shop:string;
        public PaymentType:number;

        constructor(container: JQuery) {
            super(container);
            let qryrow = Q.tryFirst(QRreport.QRywcSpecRow.getLookup().items,x => x.Id == 132)

           
            this.DateBegin = qryrow.DateBegin.toString() ?? "";
            this.DateEnd = qryrow.DateEnd.toString() ?? "";
            this.shop = qryrow.ShopId ?? "";
            this.PaymentType = qryrow.PaymentType ?? 0;
        }

        protected usePager() {
            return false;
        }

        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
    
            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
                
            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });
    
            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["  "]);
        }
        
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            opt.groupingPanel = true;
            return opt;
        }

        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: Report1332ShopPaymentTypeRefTypeService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            buttons.push(
                {
                    title: Q.text("PDf"), // *** Get button text from translation
                    cssClass: '.panel-pdf',
                    icon: 'fa fa-file-pdf-o text-red',
                    onClick: () => {
                    
                        //var row = this.view.getRows();                        
                    const request = this.getView().params as Report1332Data
                    if (!Q.isEmptyOrNull(this.DateBegin.toString())) {
                    request.FillterString = "ช่วงข้อมูลที่เลือก จากวันที่ " + this.DateBegin.substring(0, 10) + " ถึง " +this.DateEnd.substring(0, 10)
                    }

                    var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);
                    request.username = userId.Username;
                    
                  
                    let Para = Q.tryFirst(Administration.CsParaRow.getLookup().items, x => x.Id == 1)
                    
                    
                    if (!Q.isEmptyOrNull(this.shop)) {
                        let Shop = Q.tryFirst(InitialData.PsShopRow.getLookup().items, x => x.ShopId == this.shop)
                        request.ShopName = Shop.ShopRegName;
                       

                    }else{
                        request.ShopName = Para.TaxInvName;
                       
                      
                    }

                    var someDate = new Date();
                    var dd = someDate.getDate();
                    var mm = someDate.getMonth() + 1;
                    var y = someDate.getFullYear();
                    var date = dd+'/'+mm+'/'+y;
                   
                    request.Printdate = "วันที่พิมพ์ "+ date +" พิมพ์โดย "+ userId.Username;

                    request.Details = this.view.getRows();

                    console.log(request.Details)
                    console.log(request)

                    Q.postToService({ service: this.getService() + '/ExportPdf', request: request, target: '_blank' })
                        // GeniuzPOS.Purchase.PoCNRTVService.GetNextNumber                        
                    },
               
                }
            ); 
            
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );       
            return buttons;
        }


        protected createSlickGrid() {
            var grid = super.createSlickGrid();

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
            

            this.view.setSummaryOptions({
                aggregators: [

                    new Slick.Aggregators.Sum('ReceiptInAmt'),
                    new Slick.Aggregators.Sum('ReceiptOutAmt'),
                    new Slick.Aggregators.Sum('CurrencyAmt'),
                    new Slick.Aggregators.Sum('ReceiptAmt')
                ]

            });        


        return grid;
    }

    }
}